import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { GenotypingController } from 'src/controllers/genotyping.controller'
import { UpdateGenotypingDto, GenotypingDto } from 'src/dto/genotyping.dto'

const genotypingController = new GenotypingController()

export function useUpdateGenotyping() {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateGenotypingDto) => genotypingController.updateGenotyping(data),
    onSuccess: (data) => {
      queryClient.setQueryData(['getGenotypingList', farmId], (oldData: GenotypingDto[]) => {
        return oldData.map((item) => (item.idGenotipagem === data.idGenotipagem ? data : item))
      })
    },
    onError: () => {
      toast.error('Erro ao atualizar genotipagem')
    }
  })
}
